import { locationPath } from './app-routes';
import { userActions } from './user-actions';

const userActionRoutes = {
  [locationPath.USER_LIST]: userActions.MENU_USER,
  [locationPath.ROLE_LIST]: userActions.MENU_ROLE,
  [locationPath.CHANNEL_LIST]: userActions.MENU_CHANNEL,
  [locationPath.AUDIT_LOGIN_EVENTS]: userActions.MENU_AUDIT_LOGIN_EVENTS,
  [locationPath.AUDIT_HTTP_TRACE]: userActions.MENU_AUDIT_HTTP_TRACE,
  [locationPath.COMPONENT_DEMO_PAGE]: userActions.MENU_USER,
  [locationPath.ADMINISTRATION]: userActions.ADMINISTRATION,
  [locationPath.AUTHORS_WORK]: userActions.MENU_MONITORING,
  [locationPath.MONITORING]: userActions.MENU_MONITORING,
  [locationPath.CODE_CODEBOOK_TYPES]: userActions.MENU_CODE_CODEBOOK_TYPES,
  [locationPath.COMPILATIONS_VIEW]: userActions.MENU_COMPILATIONS,
};
export default userActionRoutes;
